import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`;

export const Line = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #161a30;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 300px;
  height: 42px;
  align-items: center;
  border: 1px solid #e6e8f0;
  border-radius: 8px;
`;

export const InputSearch = styled.input`
  display: flex;
  flex: 1;
  align-items: center;
  background: transparent;
  border: 0;
  padding: 10px 12px 10px 12px;
  color: #474d66;
  font-size: 14px;
  font-weight: 400;

  &::placeholder {
    color: #8f95b2;
  }

  &:focus,
  &:not(:placeholder-shown) {
    background-color: transparent;
  }
`;

interface IRow {
  display: boolean;
}

export const Row = styled.form<IRow>`
  display: ${({ display }) => (display ? 'flex' : 'none')};
  flex-direction: row;
`;

export const Button = styled.button`
  display: flex;
  flex-direction: row;
  height: 42px;
  padding: 10px 16px;
  border: 0;
  border-radius: 8px;
  background-color: #1371fe;
  color: #fff;
  align-items: center;
  justify-content: center;
  gap: 8px;

  font-size: 14px;
  font-weight: 500;

  margin-left: 8px;

  :disabled {
    background-color: #edeff4;
    color: #c1c4d6;
  }
`;

interface IDivider {
  width?: string;
  height?: string;
}

export const Divider = styled.div<IDivider>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

export const TabsContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

export const Tabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
`;

interface isActiveProps {
  isActive?: boolean;
  isDisabled?: boolean;
}

export const Indicator = styled.div<isActiveProps>`
  height: 2px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: ${({ isActive }) => (isActive ? '#1371fe' : 'transparent')};
  z-index: 2;
`;

export const Back = styled.div`
  height: 1px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: #edeff4;
  z-index: 1;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;

  & + & {
    margin-left: 48px;
  }
`;

export const Label = styled.div`
  padding-right: 6px;
  padding-left: 6px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;

export const LabelText = styled.div<isActiveProps>`
  white-space: nowrap;
  font-size: 14px;
  font-weight: ${({ isActive }) => (isActive ? '500' : '400')};
  color: ${({ isActive }) => (isActive ? '#1B203A' : '#696F8C')};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : 'unset')};
`;

interface IBody {
  show: boolean;
}

export const Body = styled.div<IBody>`
  display: ${({ show }) => (show ? 'block' : 'none')};

  background: #fff;
  width: 100%;
  height: 100%;

  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;
